<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              max-width="800px"
              scrollable
    >
        <v-card v-if="item">
            <v-toolbar dense :elevation="0">
                <v-toolbar-title>
                    Electricity charging point <strong class="text-primary-700">{{item.name}}</strong>
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn style="width:35px; height:35px" class="mr-0" icon @click="closeDialog">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider class="mx-2 mb-2"></v-divider>
            <v-card-text >
                <v-row>
                    <v-col cols="12">
                        <div>
                            <v-simple-table style="margin-top: 10px;">
                                <template v-slot:default>
                                    <tbody>
                                    <tr>
                                        <td>Devices:</td>
                                        <td>
                                            <v-chip v-for="device in item.devices" label color="green" class="ml-2">{{device}}</v-chip>
                                        </td>
<!--                                        <td>{{item.devices.join(', ')}}</td>-->
                                    </tr>
                                    <tr>
                                        <td>Address:</td>
                                        <td>{{item.address}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </div>
                    </v-col>
                </v-row>


            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "chargingPointInfoDialog",
    data: () => ({
        dialog: false,
        id: null,
        item: null,
    }),
    methods: {
        showDialog: function (id) {
            this.dialog = true;
            this.id = id;
            this.getItem();
        },
        async getItem() {
            const {data} = await this.$http.get(`/charging-points/${this.id}`);

            this.item = data;
        },
        closeDialog: function () {
            this.dialog = false;
            this.id = null;
            this.item = null;
            this.$emit('closed');
        },
    },
}
</script>

<style scoped>

</style>
